import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ExcelUploadService {

  constructor(private httpclient : HttpClient) 
  { }
  url = environment.ApiUrl + "user";

  UploadExcel(formdata : FormData){
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');  
      const httpOptions = { headers: headers };
      return this.httpclient.post(this.url+'/upload',formdata,httpOptions);
      
      
  }

}
